<template>
  <svg class="v-spinner" height="50" width="50">
    <circle
      class="path"
      cx="25"
      cy="25.2"
      r="19.9"
      fill="none"
      stroke-width="3"
    />
  </svg>
</template>

<script>
export default {
  name: "v-spinner",
};
</script>

<style lang="scss">
$color: #f39948;
.v-spinner {
  animation: spinnerRotate 2.2s linear infinite;

  .path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: spinnerAnimate 1.2s ease-in-out infinite;
    stroke-linecap: round;
    stroke: $color;
  }
}

@keyframes spinnerRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes spinnerAnimate {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 204;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}

body.ie11{
  .v-spinner{
    circle{
      display: none;
    }
    border-right: 4px solid transparent;
    border-bottom: 4px solid $color;
    border-left: 4px solid transparent;
    border-top: 4px solid transparent;
    border-radius: 50px;
    transform: rotate(45deg);
    animation: spinnerRotate 2.2s linear infinite;
  }
}
</style>
